/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `attachment` - ATTACHMENT
 * * `chat` - CHAT
 * * `comment` - COMMENT
 * * `dartboard` - DARTBOARD
 * * `dashboard` - DASHBOARD
 * * `doc` - DOC
 * * `folder` - FOLDER
 * * `form` - FORM
 * * `property` - PROPERTY
 * * `skill` - SKILL
 * * `space` - SPACE
 * * `status` - STATUS
 * * `task` - TASK
 * * `tenant` - TENANT
 * * `user` - USER
 * * `view` - VIEW
 * * `UNKNOWN` - UNKNOWN
 */
export enum EntityName {
  ATTACHMENT = 'attachment',
  CHAT = 'chat',
  COMMENT = 'comment',
  DARTBOARD = 'dartboard',
  DASHBOARD = 'dashboard',
  DOC = 'doc',
  FOLDER = 'folder',
  FORM = 'form',
  PROPERTY = 'property',
  SKILL = 'skill',
  SPACE = 'space',
  STATUS = 'status',
  TASK = 'task',
  TENANT = 'tenant',
  USER = 'user',
  VIEW = 'view',
  UNKNOWN = 'UNKNOWN',
}
